const authOrigin = import.meta.env.PUBLIC_AUTH_ORIGIN?.replace(/\/+$/, '') ?? '';
const configuredAuthStatusUrl = import.meta.env.PUBLIC_AUTH_STATUS_URL ?? '';
const configuredLoginUrl = import.meta.env.PUBLIC_LOGIN_URL ?? '';

export const authStatusUrl = configuredAuthStatusUrl || `${authOrigin || ''}/api/auth-status`;
export const remoteLoginUrl = configuredLoginUrl || (authOrigin ? `${authOrigin}/login` : '');

export function withReturnTo(url: string, returnTo: string): string {
	try {
		const loginUrl = new URL(url, returnTo);
		loginUrl.searchParams.set('returnTo', returnTo);
		return loginUrl.href;
	} catch {
		return url;
	}
}
